import { ModelMapper } from "@api/mappers/mappers.types";

import { applyHighlight } from "@utils/textUtils";
import { SearchItem, SearchItemType } from "../storeSearchInput.types";
import { HIGHLIGHT_POSTFIX, HIGHLIGHT_PREFIX } from "../storeSearchInput.config";

export const addressMapper: ModelMapper<
    woosmap.map.localities.LocalitiesPredictions,
    SearchItem
> = address => ({
    value: address.public_id,
    label: address.description,
    highlightedLabel: applyHighlight(
        HIGHLIGHT_PREFIX,
        HIGHLIGHT_POSTFIX,
        address.description,
        address.matched_substrings?.description,
    ),
    type: SearchItemType.Locality,
});
